import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';

export default class ThemeVideoModule {

	constructor(dom) {
		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this.NAME     = `THEME VIDEO MODULE`;
		this.dom      = dom;
		this.videoDom = this.dom.querySelector('[data-theme-video-module-video]');
	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	init() {
		Logger.info(`${this.NAME} > init`);
		const urlID = this.videoDom.dataset.url;
		var iframeMarkup;

		if (urlID.match('vimeo')) {
			iframeMarkup = '<iframe title="Vimeo Video Player" width="560" height="315" src="' + urlID + '" frameborder="0" allowfullscreen></iframe>';
		} else {
			iframeMarkup = '<iframe title="YouTube Video Player" width="560" height="315" src="//www.youtube.com/embed/' + urlID + '" frameborder="0" allowfullscreen></iframe>';
		}

		this.videoDom.innerHTML += iframeMarkup;
		// Do not edit below this line...
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		Logger.log(`${this.NAME} > loaded`);
	}
}

// Mixins
Object.assign(ThemeVideoModule.prototype, eventMixin);
